import React, { useEffect, useState } from "react";

// Material UI Components
import { Alert } from "@material-ui/lab";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

// Local
import CustomTable from "./Table";
import { SDCloudBackendAPIWithToken } from "../../../apis/backendAPI";
import LoaderHoc from "../../../components/HOC/LoaderHoc";
import UserProfileData from "./UserProfileData";
import ScheduleLabsTab from "./ScheduleLabsTab";
import {
  FormControl,
  TextField,
  Typography,
  Button,
  TextareaAutosize,
  Paper,
} from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import SchoolIcon from "@material-ui/icons/School";
import AssignmentIcon from "@material-ui/icons/Assignment";

// Styling
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 24px",
  },
  downloadButton: {
    borderColor: "#00AEEF !important",
    color: "#00AEEF !important",
    fontFamily: `${theme.palette.fontList?.selectedFont || "Roboto"} !important`,
    fontWeight: "600 !important",
    textTransform: "none !important",
    padding: "10px 24px !important",
    fontSize: "15px !important",
    borderRadius: "2px !important",
    backgroundColor: "#fff !important",
    "& svg": {
      fontSize: "24px !important",
    },
    "&:hover": {
      backgroundColor: "rgba(0, 174, 239, 0.08) !important",
      borderColor: "#00AEEF !important",
    },
  },
  summaryCard: {
    padding: "24px !important",
    borderRadius: "0px !important",
    boxShadow: "none !important",
    border: "1px solid #E0E0E0 !important",
    backgroundColor: "#ffffff !important",
    marginBottom: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  appBarCustom: {
    backgroundColor: "transparent !important",
    boxShadow: "none !important",
    borderBottom: "1px solid #E0E0E0 !important",
    marginBottom: "16px",
  },
  tabCustom: {
    textTransform: "none !important",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    minWidth: "120px !important",
    color: `${theme.palette.grey[600]} !important`,
    "&.Mui-selected": {
      color: "#333 !important",
    },
  },
  tabContentCard: {
    borderRadius: "0px !important",
    boxShadow: "none !important",
    border: "1px solid #E0E0E0 !important",
    backgroundColor: "#ffffff !important",
    padding: "24px !important",
    marginTop: "16px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={4}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const TrainingDetails = (props) => {
  const classes = useStyles();
  const description = props.description;
  const training_name = props.training_name;
  // States
  const [rows, setRows] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  // useEffects
  useEffect(() => {
    renderData();
  }, []);

  const columns = [
    {
      Header: "Username",
      accessor: "username",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Privilege",
      accessor: "privilege",
    },
    {
      Header: "Permission Profile",
      accessor: "profile",
    },
  ];

  let data = [];

  const renderData = async () => {
    let response = SDCloudBackendAPIWithToken()
      .post("instructer/get_training_details", {
        training_name:props.training_name,
        reference_id:props.reference_id,
      })
      .then((resp) => resp.data.users)
      .then((resp) => {
        resp.forEach((item) => {
          data.push({
            email: item.email,
            username: item.username,
            privilege: item.privilege,
            profile: item.permission_profile_name
              ? item.permission_profile_name
              : "None",
            password: item.password,
          });
        });

        setRows(data);
        setIsLoading(false);
      })
      .catch((err) => {
        let message = err.response.data.message;
        setShowNotification(true);
        setNotificationType("error");
        setNotificationMessage("Failed to retrieve the data");
      });
  };


  const renderuser = () =>{
    renderData()
  }

  const downloadCSV = (data, filename) => {
    const headers = ["Username", "Password"];
    const csvRows = [
      headers.join(","),
      ...data.map(row =>
        [row.username, row.password || row.username]
          .map(val => `"${String(val ?? "").replace(/"/g, '""')}"`)
          .join(",")
      ),
    ];
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename || "training_users"}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };
  return (
    <div style={{ padding: "8px 0" }}>
      <Grid container className={classes.root} spacing={2}>
        <Grid item xs={12}>
          {showNotification ? (
            <Alert
              onClose={() => setShowNotification(false)}
              severity={notificationType}
            >
              {notificationMessage}
            </Alert>
          ) : null}
        </Grid>
        


        <Grid item xs={12}>
          <AppBar position="static" className={classes.appBarCustom}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                TabIndicatorProps={{ style: { background: '#333', height: 2 } }}
              >
                <Tab
                  label="User Details"
                  className={classes.tabCustom}
                  {...a11yProps(0)}
                />
                <Tab
                  label="Reports"
                  className={classes.tabCustom}
                  {...a11yProps(1)}
                />
                <Tab
                  label="Schedule Labs"
                  className={classes.tabCustom}
                  {...a11yProps(2)}
                />
              </Tabs>
              <Button
                variant="outlined"
                size="large"
                className={classes.downloadButton}
                startIcon={<CloudDownloadIcon />}
                onClick={() => downloadCSV(rows, training_name)}
              >
                Download CSV
              </Button>
            </Box>
          </AppBar>
        </Grid>

        <Grid item xs={12}>
          <TabPanel value={tabIndex} index={0}>
            <Paper className={classes.tabContentCard} elevation={0}>
              <LoaderHoc isLoading={isLoading}>
                <CustomTable
                  columns={columns}
                  data={rows}
                  tableTitle="Users Enrolled"
                  dropDownValues={[]}
                />
              </LoaderHoc>
            </Paper>
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <Paper className={classes.tabContentCard} elevation={0}>
              <UserProfileData reference_id={props.reference_id} />
            </Paper>
          </TabPanel>

          <TabPanel value={tabIndex} index={2}>
            <Paper className={classes.tabContentCard} elevation={0}>
              <ScheduleLabsTab reference_id={props.reference_id} />
            </Paper>
          </TabPanel>
        </Grid>
      </Grid>
    </div>
  );
};

export default TrainingDetails;
